import { TableAsyncFlatListCell } from '../../../Table'

import {
  getDocFlowRecipientId,
  toTableAsyncFlatListCellValue,
} from './DocFlowTableCellFlat.utils'

function DocFlowTableCellFlat({ item, value, ...restProps }) {
  return (
    <TableAsyncFlatListCell
      {...restProps}
      id={getDocFlowRecipientId(item)}
      value={toTableAsyncFlatListCellValue(value)}
    />
  )
}

export default DocFlowTableCellFlat
